import * as Icons from '@lucide/svelte';
import type { IconType } from '../../components/icons/icons.types';

/** The icons of the Helpers module. */
class HelpersIconsClass {
    public readonly Check: IconType = Icons.SpellCheck;
    public readonly CheckShow: IconType = Icons.ListChecks;
    public readonly Copied: IconType = Icons.ClipboardCheck;
    public readonly Copy: IconType = Icons.ClipboardCopy;
    public readonly Diff: IconType = Icons.FileDiff;
    public readonly Download: IconType = Icons.Download;
    public readonly Helpers: IconType = Icons.Utensils;
    public readonly PlainText: IconType = Icons.PencilRuler;
}

export const HelpersIcons = new HelpersIconsClass();
